import TabMenu from '@/components/organisms/tab-menu/tab-menu';
import useAnchorMenu from '@/libraries/hooks/use-anchor-menu';

export interface AnchorMenuProps {
  /** The class name to apply */
  className?: string;
  /** The links to display in the anchor menu */
  links: Content.Properties.Link[];
}

const AnchorMenu = ({ className, links }: AnchorMenuProps) => {
  const { activeAnchor } = useAnchorMenu();

  return (
    <TabMenu
      activeItem={{
        type: 'url',
        value: activeAnchor,
      }}
      className={className}
      tabs={links}
    />
  );
};

AnchorMenu.displayName = 'AnchorMenu';

export default AnchorMenu;
